import { PartialUser, UserType } from 'types/user'

export const createPartialUser = (user: UserType): PartialUser => ({
  avatar: user.avatar,
  id: user.id,
  firstName: user.firstName,
  lastName: user.lastName,
  type: user.type,
  username: user.username,
  email: user?.email ?? '',
})
